import { AddressType, IPostalAddress } from "@/types";
import { AxiosPromise, AxiosResponse } from "axios";
import moment from "moment";
import { oc } from "ts-optchain";

import { DealernetApi } from "./DealernetApi";


import { ObjectUtil } from ".";

export class AccountService {

  public static getAccountAddress(accountId: number, addressType: AddressType): IPostalAddress {
    return ObjectUtil.createInstance<IPostalAddress>({});
  }

  

  public static async getAccountsBySalesOrgCode(accountId, userId, soldToCode): Promise<any> {
    const response = await DealernetApi.client().request({
        method: "get",
        url: `Account/GetAccountSalesOrgs?accountId=${accountId}&userId=${userId}&soldToCode=${soldToCode}`
    });

    const data = oc(response).data([]);
    return data;
}
}
